import { render, staticRenderFns } from "./RoleTable.vue?vue&type=template&id=91bf7e5a"
import script from "./RoleTable.vue?vue&type=script&lang=js"
export * from "./RoleTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports